import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useSelector } from "react-redux";
import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemText, ListSubheader } from "@mui/material";
import Image from "next/image";
import PublicIcon from '@mui/icons-material/Public';
import { InputAdornment } from "@mui/material";

const HotelDestination = ({
  setCityValue,
  cityValue,
  setSearchProduct,
  searchProduct,
  selectedValue,
  setSelectedValue,
  label,
  placeholder,
  setLoading,
  loading,
  autocompleteFirst,
  error,
  helperText
}) => {

  // const flattenedOptions=[];
  const flattenedOptions = cityValue?.reduce((acc, curr) => {
    return [
      ...acc,
      ...curr.values.map((value, index) => ({ group: curr.label, img: curr.img, ...value, _id: value._id || `${curr.label}-${index}` })),
    ];
  }, []);

  const [isOnChange, setIsOnChange] = useState(true);

  useEffect(() => {
    if (isOnChange && flattenedOptions.length > 0) {
      setIsOnChange(false);
      setSelectedValue(flattenedOptions[0]);
    }
  }, [flattenedOptions, isOnChange]);

  return (
    <>
      <Box className={`searchMenu-loc lg:px-0 js-form-dd`}
        sx={{
          "& label.Mui-focused": {
            color: "black",
          },

          "& .MuiListSubheader-root": {
            // height: "16px",
            backgroundColor: 'red',

          },
          "& .MuiInputBase-input": {
            // height: "16px",
          },
          "& .MuiAutocomplete-clearIndicator": {
            display: "none", // Hides the clear (close) button
          },

          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
          "& .MuiInput-underline:after": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
          "& .MuiAutocomplete-listbox": {
            overflow: "hidden"
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
              borderRadius: "8px",
            },
            "&:hover fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
            },
            "&.Mui-focused fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
            },
          },
          '&::-webkit-scrollbar': {
            width: '2px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
            borderRadius: '6px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#555',
          },
        }}>
        <Autocomplete
          value={selectedValue}
          onChange={(event, newValue) => {
            setSelectedValue(newValue); // Update the selected value in state
          }}
          filterOptions={x => x}
          onInputChange={(event, newInputValue) =>
            setSearchProduct(newInputValue)
          }
          ref={autocompleteFirst}
          loading={loading}
          noOptionsText={`No results found for ${searchProduct}`}
          options={flattenedOptions}
          groupBy={(option) => option.group}
          getOptionLabel={(option) => option.name} // Display name as the label in the input
          renderInput={(params) => (
            <TextField {...params} label={label}
              placeholder={placeholder}

              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <PublicIcon />
                  </InputAdornment>
                ),
                style: error ? { borderColor: 'red' } : {},
              }}
              error={error}
              helperText={helperText} />
          )}
          renderOption={(props, option) => (


            <ListItem {...props} key={option._id || option.name + option.countryName}>
              <div style={{
                minWidth: '35px',
                textAlign: 'left'
              }}>
                <Image
                  height="100"
                  width="100"
                  style={{
                    width: '20px',
                    height: '20px'
                  }} alt={option.name} src={option.img} />
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start'

              }}>
                <ListItemText primaryTypographyProps={{
                  sx: { fontSize: '14px' }
                }} primary={option.name} style={{ marginTop: 0, marginBottom: 0 }} />
                <ListItemText primaryTypographyProps={{
                  sx: { fontSize: '12px' }
                }} primary={option.countryName} style={{ marginTop: 0, marginBottom: 0 }} />
              </div>
            </ListItem>

          )}

        />
      </Box>
    </>
  );
};

export default HotelDestination;
